// extracted by mini-css-extract-plugin
export var root = "styles-module__root___rbVXK";
export var expandedRoot = "styles-module__expandedRoot___b_KUk";
export var textInput = "styles-module__textInput___eV2OP";
export var popoverRoot = "styles-module__popoverRoot___WMnNL";
export var icon = "styles-module__icon___FFEaF";
export var activeIcon = "styles-module__activeIcon___z2lH5";
export var slim = "styles-module__slim___o9Vn9";